const itchAPIBaseURL = "https://itch.io/api/1/";
const scProfileURL = "https://soundcloud.com/markkeeble";

const getMostRecentSongs = "recent-songs";
const getFeaturedSongs = "featured-songs"
const getMyGames = "games";

export { getMyGames, itchAPIBaseURL, getMostRecentSongs, getFeaturedSongs, scProfileURL }